<template>
  <div>
    <div class="video-mask">
      <div
        v-if="currentPageType == allPageType.DEFAULT"
        class="video-box type-default type-default-2"
      >
        <div class="close-btn-box" @click="closePreivwPage">
          <img class="close-btn-img" src="@/assets/images/close.png" alt="" />
        </div>
        <div class="preview-box" id="viewerBox"></div>
        <div class="preview-text-box">
          <div class="preview-text-title">{{ previewProductName }}预览画面</div>
          <div
            class="preview-text-focallength"
            v-show="
              currentAngleConfig.focalLength &&
              currentAngleConfig.focalLength != ''
            "
          >
            摄像机焦距：{{ currentAngleConfig.focalLength }}mm
          </div>
        </div>
      </div>
      <div
        v-if="currentPageType == allPageType.TYPE_HANDLE_RIGHT"
        class="video-box type-handle-right"
      >
        <div class="close-btn-box" @click="closePreivwPage">
          <img class="close-btn-img" src="@/assets/images/close.png" alt="" />
        </div>
        <div class="content-row">
          <div class="preview-box" id="viewerBox"></div>
          <div class="handler-box">
            <operate-btn
              @top="moveCamera({ direction: 'top', viewerName: 'viewerBox' })"
              @bottom="
                moveCamera({ direction: 'bottom', viewerName: 'viewerBox' })
              "
              @left="moveCamera({ direction: 'left', viewerName: 'viewerBox' })"
              @right="
                moveCamera({ direction: 'right', viewerName: 'viewerBox' })
              "
              @center="resetCameraDirection({ viewerName: 'viewerBox' })"
              status="normal"
              size="120"
              :unable="getDisabledDirection('viewerBox')"
            ></operate-btn>
          </div>
        </div>
        <div class="text-row">
          <div class="preview-text-box">
            <div class="preview-text-title">
              {{ previewProductName }}预览画面
            </div>
            <div
              class="preview-text-focallength"
              v-show="
                currentAngleConfig.focalLength &&
                currentAngleConfig.focalLength != ''
              "
            >
              摄像机焦距：{{ currentAngleConfig.focalLength }}mm
            </div>
          </div>
          <span class="handler-text handler-text-style">云台操作</span>
        </div>
      </div>
      <div
        v-if="currentPageType == allPageType.TYPE_SLIDE_DOWN"
        class="video-box type-slide-down"
      >
        <div class="close-btn-box" @click="closePreivwPage">
          <img class="close-btn-img" src="@/assets/images/close.png" alt="" />
        </div>
        <div class="content-row">
          <div class="preview-box" id="viewerBox"></div>
        </div>
        <div class="preview-text preview-text-style">
          {{ previewProductName }}预览画面
        </div>
        <div
          class="preview-text-focallength"
          v-show="false"
        >
          摄像机焦距：{{ currentAngleConfig.focalLength }}mm
        </div>
        <div class="slide-row">
          <zoom-btn
            :zoomsize="curretnZoomConfig.zoomsize"
            :point="curretnZoomConfig.point"
            :initzoom="curretnZoomConfig.initzoom"
            :factor="curretnZoomConfig.factor"
            :boxsize="curretnZoomConfig.boxsize"
            @setzoom="
              (zoom) => {
                changeViewerBoxZoom({
                  zoom,
                  initzoom: curretnZoomConfig.initzoom,
                });
              }
            "
          >
          </zoom-btn>
        </div>
        <div class="slide-text slide-text-style">变焦操作</div>
      </div>
      <div
        v-if="currentPageType == allPageType.TYPE_HANDLE_SLIDE_DOWN"
        class="video-box type-handle-slide-down"
      >
        <div class="close-btn-box" @click="closePreivwPage">
          <img class="close-btn-img" src="@/assets/images/close.png" alt="" />
        </div>
        <div class="content-row">
          <div class="preview-box" id="viewerBox"></div>
        </div>
        <div class="preview-text preview-text-style">
          {{ previewProductName }}预览画面
        </div>
        <div
          class="preview-text-focallength"
          v-show="false"
        >
          摄像机焦距：{{ currentAngleConfig.focalLength }}mm
        </div>
        <div class="operate-box">
          <div class="slide-box">
            <zoom-btn
              :zoomsize="curretnZoomConfig.zoomsize"
              :point="curretnZoomConfig.point"
              :initzoom="curretnZoomConfig.initzoom"
              :factor="curretnZoomConfig.factor"
              :boxsize="curretnZoomConfig.boxsize"
              @setzoom="
                (zoom) => {
                  changeViewerBoxZoom({
                    zoom,
                    initzoom: curretnZoomConfig.initzoom,
                  });
                }
              "
            >
            </zoom-btn>
          </div>
          <div class="handler-box">
            <operate-btn
              @top="moveCamera({ direction: 'top', viewerName: 'viewerBox' })"
              @bottom="
                moveCamera({ direction: 'bottom', viewerName: 'viewerBox' })
              "
              @left="moveCamera({ direction: 'left', viewerName: 'viewerBox' })"
              @right="
                moveCamera({ direction: 'right', viewerName: 'viewerBox' })
              "
              @center="resetCameraDirection({ viewerName: 'viewerBox' })"
              status="normal"
              size="80"
              :unable="getDisabledDirection('viewerBox')"
            ></operate-btn>
          </div>
        </div>
        <div class="text-row">
          <span class="slide-text slide-text-style">变焦操作</span>

          <span class="handler-text handler-text-style">云台操作</span>
        </div>
      </div>
      <div
        v-if="currentPageType == allPageType.TYPE_DOUBLE_HANDLE_SLIDE_DOWN"
        class="video-box type-double-handle-slide-down"
      >
        <div class="close-btn-box" @click="closePreivwPage">
          <img class="close-btn-img" src="@/assets/images/close.png" alt="" />
        </div>
        <p class="preview-title">{{ previewProductName }}预览画面</p>
        <div class="content-row">
          <div class="preview-box" id="viewerBox"></div>
        </div>
        <div class="preview-text preview-text-style">
          枪机预览画面<span
            class="preview-text-focallength"
            v-show="
              currentAngleConfig.focalLengthQiang &&
              currentAngleConfig.focalLengthQiang != ''
            "
            >摄像机焦距：{{ currentAngleConfig.focalLengthQiang }}mm</span
          >
        </div>
        <div class="divider"></div>
        <div class="content-row content-second-row">
          <div class="preview-box" id="viewerDome"></div>
        </div>
        <div class="preview-text preview-text-style" style="margin-bottom: 0">
          球机预览画面<span
            class="preview-text-focallength"
            v-show="false"
            >摄像机焦距：{{ currentAngleConfig.focalLengthQiu }}mm</span
          >
        </div>
        <div class="operate-box">
          <div class="slide-box">
            <zoom-btn
              :zoomsize="curretnZoomConfig.zoomsize"
              :point="curretnZoomConfig.point"
              :initzoom="curretnZoomConfig.initzoom"
              :factor="curretnZoomConfig.factor"
              :boxsize="curretnZoomConfig.boxsize"
              @setzoom="
                (zoom) => {
                  changeViewerDomeZoom({
                    zoom,
                    initzoom: curretnZoomConfig.initzoom,
                  });
                }
              "
            >
            </zoom-btn>
          </div>
          <div class="handler-box">
            <operate-btn
              @top="moveCamera({ direction: 'top', viewerName: 'viewerDome' })"
              @bottom="
                moveCamera({ direction: 'bottom', viewerName: 'viewerDome' })
              "
              @left="
                moveCamera({ direction: 'left', viewerName: 'viewerDome' })
              "
              @right="
                moveCamera({ direction: 'right', viewerName: 'viewerDome' })
              "
              @center="resetCameraDirection({ viewerName: 'viewerDome' })"
              status="normal"
              size="80"
              :unable="getDisabledDirection('viewerDome')"
            ></operate-btn>
          </div>
        </div>
        <div class="text-row">
          <span class="slide-text slide-text-style">变焦操作</span>

          <span class="handler-text handler-text-style">云台操作</span>
        </div>
      </div>
      <div
        v-if="currentPageType == allPageType.TYPE_DOUBLE_HANDLE_RIGHT"
        class="video-box type-double-handle-right"
      >
        <div class="close-btn-box" @click="closePreivwPage">
          <img class="close-btn-img" src="@/assets/images/close.png" alt="" />
        </div>
        <p class="preview-title">{{ previewProductName }}预览画面</p>
        <div class="content-row">
          <div class="preview-box" id="viewerBox"></div>
        </div>
        <div class="preview-text preview-text-style">
          枪机预览画面<span
            class="preview-text-focallength"
            v-show="
              currentAngleConfig.focalLengthQiang &&
              currentAngleConfig.focalLengthQiang != ''
            "
            >摄像机焦距：{{ currentAngleConfig.focalLengthQiang }}mm</span
          >
        </div>
        <div class="divider"></div>
        <div class="operate-box content-second-row">
          <div class="preview-box" id="viewerDome"></div>
          <div class="handler-box">
            <operate-btn
              @top="moveCamera({ direction: 'top', viewerName: 'viewerDome' })"
              @bottom="
                moveCamera({ direction: 'bottom', viewerName: 'viewerDome' })
              "
              @left="
                moveCamera({ direction: 'left', viewerName: 'viewerDome' })
              "
              @right="
                moveCamera({ direction: 'right', viewerName: 'viewerDome' })
              "
              @center="resetCameraDirection({ viewerName: 'viewerDome' })"
              status="normal"
              size="120"
              :unable="getDisabledDirection('viewerDome')"
            ></operate-btn>
          </div>
        </div>
        <div class="text-row">
          <div class="preview-text preview-text-style">
            球机预览画面<span
              class="preview-text-focallength"
              v-show="
                currentAngleConfig.focalLengthQiu &&
                currentAngleConfig.focalLengthQiu != ''
              "
              >摄像机焦距：{{ currentAngleConfig.focalLengthQiu }}mm</span
            >
          </div>
          <span class="handler-text handler-text-style">云台操作</span>
        </div>
      </div>
      <div
        v-if="currentPageType == allPageType.TYPE_VIDEO"
        class="video-box type-video"
      >
        <video
          autoplay=""
          loop=""
          muted=""
          playsinline=""
          controls=""
          class="preview-video"
        >
          <source :src="videoUrl" type="video/mp4" />
        </video>
        <div class="close-btn-box" @click="closePreivwPage">
          <img class="close-btn-img" src="@/assets/images/close.png" alt="" />
        </div>
      </div>
      <div
        v-if="currentPageType == allPageType.TYPE_DOUBLE_HANDLE_SLIDE_DOWN_2"
        class="video-box type-double-handle-slide-down"
      >
        <div class="close-btn-box" @click="closePreivwPage">
          <img class="close-btn-img" src="@/assets/images/close.png" alt="" />
        </div>
        <p class="preview-title">{{ previewProductName }}预览画面</p>
        <div class="content-row">
          <img style="width: 100%; display: block" :src="singeImgUrl" />
        </div>
        <div class="preview-text preview-text-style">
          枪机预览画面<span
            class="preview-text-focallength"
            v-show="
              currentAngleConfig.focalLengthQiang &&
              currentAngleConfig.focalLengthQiang != ''
            "
            >摄像机焦距：{{ currentAngleConfig.focalLengthQiang }}mm</span
          >
        </div>
        <div class="divider"></div>
        <div class="content-row content-second-row">
          <div class="preview-box" id="viewerDome"></div>
        </div>
        <div class="preview-text preview-text-style" style="margin-bottom: 0">
          球机预览画面<span
            class="preview-text-focallength"
            v-show="false"
            >摄像机焦距：{{ currentAngleConfig.focalLengthQiu }}mm</span
          >
        </div>
        <div class="operate-box">
          <div class="slide-box">
            <zoom-btn
              :zoomsize="curretnZoomConfig.zoomsize"
              :point="curretnZoomConfig.point"
              :initzoom="curretnZoomConfig.initzoom"
              :factor="curretnZoomConfig.factor"
              :boxsize="curretnZoomConfig.boxsize"
              @setzoom="
                (zoom) => {
                  changeViewerDomeZoom({
                    zoom,
                    initzoom: curretnZoomConfig.initzoom,
                  });
                }
              "
            >
            </zoom-btn>
          </div>
          <div class="handler-box">
            <operate-btn
              @top="moveCamera({ direction: 'top', viewerName: 'viewerDome' })"
              @bottom="
                moveCamera({ direction: 'bottom', viewerName: 'viewerDome' })
              "
              @left="
                moveCamera({ direction: 'left', viewerName: 'viewerDome' })
              "
              @right="
                moveCamera({ direction: 'right', viewerName: 'viewerDome' })
              "
              @center="resetCameraDirection({ viewerName: 'viewerDome' })"
              status="normal"
              size="80"
              :unable="getDisabledDirection('viewerDome')"
            ></operate-btn>
          </div>
        </div>
        <div class="text-row">
          <span class="slide-text slide-text-style">变焦操作</span>

          <span class="handler-text handler-text-style">云台操作</span>
        </div>
      </div>
      <div
        v-if="currentPageType == allPageType.TYPE_DOUBLE_HANDLE_RIGHT_2"
        class="video-box type-double-handle-right"
      >
        <div class="close-btn-box" @click="closePreivwPage">
          <img class="close-btn-img" src="@/assets/images/close.png" alt="" />
        </div>
        <p class="preview-title">{{ previewProductName }}预览画面</p>
        <div class="content-row">
          <img style="width: 100%; display: block" :src="singeImgUrl" />
        </div>
        <div class="preview-text preview-text-style">
          枪机预览画面<span
            class="preview-text-focallength"
            v-show="
              currentAngleConfig.focalLengthQiang &&
              currentAngleConfig.focalLengthQiang != ''
            "
            >摄像机焦距：{{ currentAngleConfig.focalLengthQiang }}mm</span
          >
        </div>
        <div class="divider"></div>
        <div class="operate-box content-second-row">
          <div class="preview-box" id="viewerDome"></div>
          <div class="handler-box">
            <operate-btn
              @top="moveCamera({ direction: 'top', viewerName: 'viewerDome' })"
              @bottom="
                moveCamera({ direction: 'bottom', viewerName: 'viewerDome' })
              "
              @left="
                moveCamera({ direction: 'left', viewerName: 'viewerDome' })
              "
              @right="
                moveCamera({ direction: 'right', viewerName: 'viewerDome' })
              "
              @center="resetCameraDirection({ viewerName: 'viewerDome' })"
              status="normal"
              size="120"
              :unable="getDisabledDirection('viewerDome')"
            ></operate-btn>
          </div>
        </div>
        <div class="text-row">
          <div class="preview-text preview-text-style">
            球机预览画面<span
              class="preview-text-focallength"
              v-show="
                currentAngleConfig.focalLengthQiu &&
                currentAngleConfig.focalLengthQiu != ''
              "
              >摄像机焦距：{{ currentAngleConfig.focalLengthQiu }}mm</span
            >
          </div>
          <span class="handler-text handler-text-style">云台操作</span>
        </div>
      </div>
      <div
        v-if="currentPageType == allPageType.DEFAULT_2"
        class="video-box type-default type-default-2"
      >
        <div class="close-btn-box" @click="closePreivwPage">
          <img class="close-btn-img" src="@/assets/images/close.png" alt="" />
        </div>
        <div class="preview-box" id="viewerBox">
          <img style="width: 100%; display: block" :src="singeImgUrl" />
        </div>
        <div class="preview-text-box">
          <div class="preview-text-title">{{ previewProductName }}预览画面</div>
          <div
            class="preview-text-focallength"
            v-show="
              currentAngleConfig.focalLength &&
              currentAngleConfig.focalLength != ''
            "
          >
            摄像机焦距：{{ currentAngleConfig.focalLength }}mm
          </div>
        </div>
      </div>
      <div
        v-if="currentPageType == allPageType.DEFAULT_3"
        class="video-box type-default type-default-2 type-default-3"
      >
        <div class="close-btn-box" @click="closePreivwPage">
          <img class="close-btn-img" src="@/assets/images/close.png" alt="" />
        </div>
        <div class="preview-box" id="viewerBox">
          <img style="width: 100%; display: block" :src="singeImgUrl" />
        </div>
        <div class="preview-text-box">
          <div class="preview-text-title">{{ previewProductName }}预览画面</div>
          <div
            class="preview-text-focallength"
            v-show="
              currentAngleConfig.focalLength &&
              currentAngleConfig.focalLength != ''
            "
          >
            摄像机焦距：{{ currentAngleConfig.focalLength }}mm
          </div>
        </div>
      </div>
      <div
        v-if="currentPageType == allPageType.TYPE_SLIDE_DOWN_2"
        class="video-box type-slide-down"
      >
        <div class="close-btn-box" @click="closePreivwPage">
          <img class="close-btn-img" src="@/assets/images/close.png" alt="" />
        </div>
        <div class="content-row" style="overflow: hidden">
          <img
            :style="
              'width: 100%; display: block;transition: all 2s;transform: scale(' +
              currentScale +
              ');'
            "
            :src="singeImgUrl"
          />
        </div>
        <div class="preview-text preview-text-style">
          {{ previewProductName }}预览画面
        </div>
        <div
          class="preview-text-focallength"
          v-show="false"
        >
          摄像机焦距：{{ currentAngleConfig.focalLength }}mm
        </div>
        <div class="slide-row">
          <zoom-btn
            :zoomsize="curretnZoomConfig.zoomsize"
            :point="curretnZoomConfig.point"
            :initzoom="curretnZoomConfig.initzoom"
            :factor="curretnZoomConfig.factor"
            :boxsize="curretnZoomConfig.boxsize"
            @setzoom="
              (zoom) => {
                changeViewerBoxZoom2({
                  zoom,
                  initzoom: curretnZoomConfig.zoomsize,
                });
              }
            "
          >
          </zoom-btn>
        </div>
        <div class="slide-text slide-text-style">变焦操作</div>
      </div>
      <div
        v-if="currentPageType == allPageType.TYPE_THERMAL_IMG"
        class="video-box type-default type-thermal-img"
      >
        <div class="close-btn-box" @click="closePreivwPage">
          <img class="close-btn-img" src="@/assets/images/close.png" alt="" />
        </div>
        <div class="preview-text-box">
          <div class="preview-text-title">{{ previewProductName }}预览画面</div>
          <div
            class="preview-text-focallength"
            v-show="
              currentAngleConfig.focalLength &&
              currentAngleConfig.focalLength != ''
            "
          >
            摄像机焦距：{{ currentAngleConfig.focalLength }}mm
          </div>
        </div>
        <div class="type-thermal-img-box">
          <div class="type-thermal-img-left">
            <img :src="thermalImgLeft" />
          </div>
          <div class="type-thermal-img-right">
            <img :src="thermalImgRight" />
          </div>
        </div>
        <div class="type-thermal-img-box">
          <div class="type-thermal-img-title-left">可见光画面</div>
          <div class="type-thermal-img-title-right">热成像画面</div>
        </div>
      </div>
      <div
        v-if="currentPageType == allPageType.TYPE_INSPECTION_INTRO"
        class="inspection-intro"
      >
        <div class="close-btn-box" @click="closePreivwPage">
          <img class="close-btn-img" src="@/assets/images/close.png" alt="" />
        </div>
        <div class="modal-header">
          <img class="logo" src="https://media.tp-link.com.cn/webresource/www_data/v3/imgs/icon/tp_logo_white.png" />
        </div>
        <div class="inspection-intro-title">
          巡课巡查系统介绍
        </div>
        <div class="inspection-intro-desc">
          TP-LINK针对线下巡课效率低、留证难、爬楼累的痛点，为学校用户开发了线上巡课巡查系统，集成了全面的基础数据管理功能，涵盖学段、教职工、教室、班级及课表管理，确保信息准确无误。
        </div>
        <ul class="inspection-intro-spolight">
          <li>支持巡课任务计划管理、待办事项提醒及进度跟踪，学校还可自定义巡检模板，灵活配置评分项目和标准。</li>
          <li>支持巡课数据看板、历史记录查询和智能巡课分析，帮助学校及时发现并解决课堂异常行为，助力学校提升教学质量和管理水平。</li>
          <li>通过精细化角色权限设置，满足不同人员的个性化需求，并保障数据安全。</li>
          <li>系统兼容PC端与移动端，可实时记录巡课情况，确保巡课流程高效、透明。</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
//props参数status表示状态：normal、disableupdown、disableleftright；size表示尺寸：120、80；unable表示禁止方向：left、top、right、bottom
// zoomsize表示变焦范围 传23；point表示圆点数量 传46；initzoom表示初始变焦 传10；factor表示一倍变焦对应多少个圆点 传2；boxsize表示空间大小可传big或者small
import { pageType } from "@/utils/PreviewConsts";
import { zoomConfig } from "@/utils/ZoomConfig";
import { CameraAngleLimitationConfig } from "@/utils/CameraAngleLimitationConfig";

import commom from "@/mixin/common"; // 引入 mixin

import { Viewer } from "@photo-sphere-viewer/core";
import { EquirectangularTilesAdapter } from "@photo-sphere-viewer/equirectangular-tiles-adapter";

import OperateBtn from "./OperateBtn.vue";
import ZoomBtn from "./ZoomBtn.vue";
export default {
  name: "VideoPreview",
  components: {
    OperateBtn,
    ZoomBtn,
  },
  mixins: [commom],
  props: {
    currentPageType: {
      type: String,
      required: true,
    },
    previewInfo: {
      type: Object,
      required: true,
    },
    isShowPreview: {
      type: Boolean,
      required: true,
    },
    previewProductName: {
      type: String,
      default: "巡课摄像机",
    },
    previewZoomType: {
      type: String,
      default: "X_23",
    },
    productId: {
      required: true,
    },
  },
  data() {
    return {
      allPageType: pageType,
      zoomConfig: zoomConfig,
      CameraAngleLimitationConfig: CameraAngleLimitationConfig,
      //枪机的全景图
      viewerBox: null,
      //球机的全景图
      viewerDome: null,
      videoUrl: "https://media.tp-link.com.cn/webresource/act/vr/video/5.mp4",
      //滑动组件的初始放大倍数
      //全景图默认初始的zoomlevel
      defaultZoomLevel: 50,
      defaultZoomLvl_Dome: 50,
      singeImgUrl:
        "https://media.tp-link.com.cn/webresource/www_data/v3/imgs/icon/background.png",
      currentScale: 1,
      disabledDirection: {
        viewerBox: "",
        viewerDome: "",
      },
      thermalImgLeft:
        "https://media.tp-link.com.cn/webresource/www_data/v3/imgs/icon/background.png",
      thermalImgRight:
        "https://media.tp-link.com.cn/webresource/www_data/v3/imgs/icon/background.png",
    };
  },
  computed: {
    viewerBoxPictureBaseUrl() {
      return `/webresource/act/vr/pictureinpicture/${this.previewInfo.viewerBoxPictureFile}/img_low.jpg`;
    },
    viewerDomePictureBaseUrl() {
      return `/webresource/act/vr/pictureinpicture/${this.previewInfo.viewerDomePictureFile}/img_low.jpg`;
    },
    curretnZoomConfig() {
      return this.zoomConfig[this.previewZoomType];
    },
    currentAngleConfig() {
      return this.CameraAngleLimitationConfig[this.productId] !== undefined
        ? this.CameraAngleLimitationConfig[this.productId]
        : this.CameraAngleLimitationConfig["default"];
    },
  },
  watch: {
    isShowPreview(newValue) {
      if (!newValue) {
        //关闭弹窗，销毁当前全景图
        return;
      }
      if (this.isEmptyString(this.currentPageType)) {
        return;
      }
      if (
        this.currentPageType == this.allPageType.DEFAULT ||
        this.currentPageType == this.allPageType.TYPE_HANDLE_RIGHT ||
        this.currentPageType == this.allPageType.TYPE_SLIDE_DOWN ||
        this.currentPageType == this.allPageType.TYPE_HANDLE_SLIDE_DOWN
      ) {
        //初始化一个全景图(枪机全景图)
        this.initViewerBox();
      } else if (
        this.currentPageType ==
          this.allPageType.TYPE_DOUBLE_HANDLE_SLIDE_DOWN ||
        this.currentPageType == this.allPageType.TYPE_DOUBLE_HANDLE_RIGHT
      ) {
        //初始化两个全景图，枪机和球机
        this.initViewerBox();
        this.initViewerDome();
      } else if (this.currentPageType == this.allPageType.TYPE_VIDEO) {
        this.initVideo();
      } else if (
        this.currentPageType == this.allPageType.TYPE_DOUBLE_HANDLE_SLIDE_DOWN_2
      ) {
        this.initViewerDome2();
      } else if (
        this.currentPageType == this.allPageType.TYPE_DOUBLE_HANDLE_RIGHT_2
      ) {
        this.initViewerDome2();
      } else if (this.currentPageType == this.allPageType.TYPE_THERMAL_IMG) {
        this.initTheramalImg();
      } else if (
        this.currentPageType == this.allPageType.DEFAULT_2 ||
        this.currentPageType == this.allPageType.DEFAULT_3 ||
        this.currentPageType == this.allPageType.TYPE_SLIDE_DOWN_2
      ) {
        this.initViewerImg();
      }
    },
    currentPageType(newValue) {
      if (newValue == this.allPageType.TYPE_SLIDE_DOWN) {
        // 2x 对应 zoonmlvl 40
        // 5x 对应 zoonmlvl 100
        if (this.curretnZoomConfig.defaultZoomLevel != null) {
          this.defaultZoomLevel = this.curretnZoomConfig.defaultZoomLevel;
        } else {
          this.defaultZoomLevel = 40;
        }
      }

      if (newValue == this.allPageType.TYPE_HANDLE_SLIDE_DOWN) {
        // 10x 对应 zoonmlvl 43
        // 23x 对应 zoonmlvl 100
        if (this.curretnZoomConfig.defaultZoomLevel != null) {
          this.defaultZoomLevel = this.curretnZoomConfig.defaultZoomLevel;
        } else {
          this.defaultZoomLevel = 43;
        }
      }
      if (
        newValue == this.allPageType.TYPE_DOUBLE_HANDLE_SLIDE_DOWN ||
        newValue == this.allPageType.TYPE_DOUBLE_HANDLE_SLIDE_DOWN_2
      ) {
        if (this.curretnZoomConfig.defaultZoomLevel != null) {
          this.defaultZoomLevel = this.curretnZoomConfig.defaultZoomLevel;
        } else {
          this.defaultZoomLevel = 43;
        }
      }
    },
  },
  methods: {
    closePreivwPage() {
      //销毁全景图实例
      if (this.viewerBox != null) {
        this.viewerBox.destroy();
        this.viewerBox = null;
      }
      if (this.viewerDome != null) {
        this.viewerDome.destroy();
        this.viewerDome = null;
      }
      this.$emit("close");
      //将pagetype设置为空，通过v-if删除已经创建好的canvas

      this.$emit("resetPageType");
      //平面图恢复初始状态
      this.singeImgUrl =
        "https://media.tp-link.com.cn/webresource/www_data/v3/imgs/icon/background.png";
      this.thermalImgLeft =
        "https://media.tp-link.com.cn/webresource/www_data/v3/imgs/icon/background.png";
      this.thermalImgRight =
        "https://media.tp-link.com.cn/webresource/www_data/v3/imgs/icon/background.png";
    },
    initTheramalImg() {
      this.$nextTick(() => {
        this.thermalImgLeft = this.previewInfo.thermalImgLeft;
        this.thermalImgRight = this.previewInfo.thermalImgRight;
      });
    },
    initViewerBox() {
      if (!this.isEmptyObject(this.viewerBox)) return;
      this.$nextTick(() => {
        this.viewerBox = new Viewer({
          container: "viewerBox",
          adapter: EquirectangularTilesAdapter,
          mousewheel: false,
          mousemove: false,
          panorama: {
            width: 12000,
            cols: this.previewInfo.viewerBoxCols,
            rows: this.previewInfo.viewerBoxRows,
            baseUrl: this.viewerBoxPictureBaseUrl,
            tileUrl: (col, row) => {
              return `/webresource/act/vr/pictureinpicture/${this.previewInfo.viewerBoxPictureFile}/img_${col}_${row}.jpg`;
            },
          },
          navbar: false,
          defaultZoomLvl: this.previewInfo.defaultZoomLevel
            ? this.previewInfo.defaultZoomLevel
            : this.defaultZoomLevel,
          defaultPitch: this.previewInfo.defaultPitch
            ? this.previewInfo.defaultPitch
            : 0,
          defaultYaw: this.previewInfo.defaultYaw
            ? this.previewInfo.defaultYaw
            : 0,
        });
      });
    },
    initViewerDome() {
      if (!this.isEmptyObject(this.viewerDome)) return;
      this.$nextTick(() => {
        this.viewerDome = new Viewer({
          container: "viewerDome",
          adapter: EquirectangularTilesAdapter,
          mousewheel: false,
          mousemove: false,
          panorama: {
            width: 12000,
            cols: this.previewInfo.viewerDomeCols,
            rows: this.previewInfo.viewerDomeRows,
            baseUrl: this.viewerDomePictureBaseUrl,
            tileUrl: (col, row) => {
              return `/webresource/act/vr/pictureinpicture/${this.previewInfo.viewerDomePictureFile}/img_${col}_${row}.jpg`;
            },
          },
          navbar: false,
          defaultZoomLvl: this.previewInfo.defaultZoomLevel
            ? this.previewInfo.defaultZoomLevel
            : this.defaultZoomLevel,
        });
      });
    },
    initViewerDome2() {
      if (!this.isEmptyObject(this.viewerDome)) return;
      this.$nextTick(() => {
        this.singeImgUrl = this.previewInfo.viewerDomeImgUrl;
        this.viewerDome = new Viewer({
          container: "viewerDome",
          adapter: EquirectangularTilesAdapter,
          mousewheel: false,
          mousemove: false,
          panorama: {
            width: 12000,
            cols: this.previewInfo.viewerDomeCols,
            rows: this.previewInfo.viewerDomeRows,
            baseUrl: this.viewerDomePictureBaseUrl,
            tileUrl: (col, row) => {
              return `/webresource/act/vr/pictureinpicture/${this.previewInfo.viewerDomePictureFile}/img_${col}_${row}.jpg`;
            },
          },
          navbar: false,
          defaultZoomLvl: this.previewInfo.defaultZoomLevel
            ? this.previewInfo.defaultZoomLevel
            : this.defaultZoomLevel,
          defaultPitch: this.previewInfo.defaultPitch
            ? this.previewInfo.defaultPitch
            : 0,
        });
      });
    },
    initViewerImg() {
      if (!this.isEmptyObject(this.viewerDome)) return;
      this.$nextTick(() => {
        this.currentScale = 1;
        this.singeImgUrl = this.previewInfo.viewerDomeImgUrl;
      });
    },
    initVideo() {
      this.videoUrl = this.previewInfo.videoUrl;
    },
    isAngleInRange(angle, min, max) {
      // angle 参数是 0-360 度范围的角度

      //点击向右的按钮，angle从零开始增加，点击向左按钮angle从360度开始减小
      // 将限制角度转换为 0-360 范围进行比较
      let min360, max360;

      if (min >= -180 && max <= 180) {
        // 标准范围情况 [-180, 180]
        if (min < 0) min360 = 360 + min;
        else min360 = min;

        if (max < 0) max360 = 360 + max;
        else max360 = max;

        // 如果 min360 > max360，说明范围跨越了0点
        if (min360 <= max360) {
          return angle >= min360 && angle <= max360;
        } else {
          return angle >= min360 || angle <= max360;
        }
      } else {
        // 扩展范围情况
        if (min < -180) {
          // 左侧扩展，如 [-203.9, 180]
          min360 = 360 + min; // 360 - 203.9 = 156.1
          max360 = max; // 180

          // 范围是 [156.1, 360] U [0, 180]
          return angle >= min360 || angle <= max360;
        } else if (max > 180) {
          // 右侧扩展，如 [-180, 203.9]
          min360 = 360 + min; // 360 - 180 = 180
          max360 = max; // 203.9

          // 范围是 [180, 203.9]
          return angle >= min360 && angle <= max360;
        }
      }

      return true;
    },
    moveCamera({ direction, viewerName }) {
      //如果需要修改viewerName，则在pictureInfo中规定viewerName，然后这里获取this中对应的viewer
      let viewer = null;
      if (viewerName == "viewerBox") {
        viewer = this.viewerBox;
      } else if (viewerName == "viewerDome") {
        viewer = this.viewerDome;
      } else {
        console.log("moveCamera方法未找到对应viewer");
      }
      if (!viewer) return;
      const currentPosition = viewer.getPosition();
      const step = Math.PI / 18;

      const angleConfig = this.currentAngleConfig;

      let newYaw = currentPosition.yaw;
      let newPitch = currentPosition.pitch;

      // 处理垂直转动
      if (angleConfig.verticalMode !== "fixed") {
        switch (direction) {
          case "top":
            if (angleConfig.verticalMode === "limited") {
              const maxPitchRad = (angleConfig.vertical.max * Math.PI) / 180;
              newPitch = Math.min(maxPitchRad, newPitch + step);
              // 检查是否已到达上限
              if (newPitch >= maxPitchRad - 0.01) {
                this.disabledDirection[viewerName] = "top";
              } else {
                this.disabledDirection[viewerName] = "";
              }
            } else {
              // full模式下不限制垂直角度，但为了用户体验仍保留±90度限制
              newPitch = Math.min(Math.PI / 2, newPitch + step);
            }
            break;
          case "bottom":
            if (angleConfig.verticalMode === "limited") {
              const minPitchRad = (angleConfig.vertical.min * Math.PI) / 180;
              newPitch = Math.max(minPitchRad, newPitch - step);
              // 检查是否已到达下限
              if (newPitch <= minPitchRad + 0.01) {
                this.disabledDirection[viewerName] = "bottom";
              } else {
                this.disabledDirection[viewerName] = "";
              }
            } else {
              // full模式下不限制垂直角度，但为了用户体验仍保留±90度限制
              newPitch = Math.max(-Math.PI / 2, newPitch - step);
            }
            break;
        }
      } else {
        // 在fixed模式下，始终禁用上下方向
        if (direction === "top" || direction === "bottom") {
          this.disabledDirection[viewerName] = direction;
          return;
        }
      }

      if (angleConfig.horizontalMode !== "fixed") {
        switch (direction) {
          case "left":
            if (angleConfig.horizontalMode === "limited") {
              newYaw = (newYaw - step + 2 * Math.PI) % (2 * Math.PI);
              const yawDegree = (newYaw * 180) / Math.PI;

              // 检查新角度是否在允许范围内
              if (
                !this.isAngleInRange(
                  yawDegree,
                  angleConfig.horizontal.min,
                  angleConfig.horizontal.max
                )
              ) {
                this.disabledDirection[viewerName] = "left";
                return;
              } else {
                this.disabledDirection[viewerName] = "";
              }
            } else {
              // full模式下允许无限旋转
              newYaw = (newYaw - step + 2 * Math.PI) % (2 * Math.PI);
            }
            break;

          case "right":
            if (angleConfig.horizontalMode === "limited") {
              newYaw = (newYaw + step) % (2 * Math.PI);
              const yawDegree = (newYaw * 180) / Math.PI;

              // 检查新角度是否在允许范围内
              if (
                !this.isAngleInRange(
                  yawDegree,
                  angleConfig.horizontal.min,
                  angleConfig.horizontal.max
                )
              ) {
                this.disabledDirection[viewerName] = "right";
                return;
              } else {
                this.disabledDirection[viewerName] = "";
              }
            } else {
              // full模式下允许无限旋转
              newYaw = (newYaw + step) % (2 * Math.PI);
            }
            break;
        }
      } else {
        // 在fixed模式下，始终禁用左右方向
        if (direction === "left" || direction === "right") {
          this.disabledDirection[viewerName] = direction;
          return;
        }
      }

      viewer.animate({
        yaw: newYaw,
        pitch: newPitch,
        speed: 500, // 动画速度(毫秒)
      });
    },

    // 重置摄像头方向
    resetCameraDirection({ viewerName }) {
      let viewer = null;
      if (viewerName == "viewerBox") {
        viewer = this.viewerBox;
      } else if (viewerName == "viewerDome") {
        viewer = this.viewerDome;
      } else {
        console.log("moveCamera方法未找到对应viewer");
      }
      if (!viewer) return;

      let resetYaw = 0;
      let resetPitch = 0;
      // 如果是fixed模式，则不执行重置操作
      const angleConfig = this.currentAngleConfig;
      if (
        angleConfig.horizontalMode === "fixed" &&
        angleConfig.verticalMode === "fixed"
      ) {
        return;
      }

      // 处理水平方向重置
      if (angleConfig.horizontalMode === "limited") {
        if (0 < angleConfig.horizontal.min || 0 > angleConfig.horizontal.max) {
          // 0度不在允许范围内，使用范围中点
          resetYaw =
            (((angleConfig.horizontal.min + angleConfig.horizontal.max) / 2) *
              Math.PI) /
            180;
        }
      }
      // 如果是full模式，重置为0度（中心位置）

      // 处理垂直方向重置
      if (angleConfig.verticalMode === "limited") {
        if (0 < angleConfig.vertical.min || 0 > angleConfig.vertical.max) {
          // 0度不在允许范围内，使用范围中点
          resetPitch =
            (((angleConfig.vertical.min + angleConfig.vertical.max) / 2) *
              Math.PI) /
            180;
        }
      } else if (angleConfig.verticalMode === "fixed") {
        // 固定模式使用配置的固定角度
        resetPitch = (angleConfig.vertical.min * Math.PI) / 180;
      }
      // 如果是full模式，重置为0度（水平位置）

      this.disabledDirection[viewerName] = "";

      viewer.animate({
        yaw: resetYaw,
        pitch: resetPitch,
        speed: 500,
      });
    },

    // 获取指定viewer的禁用方向
    getDisabledDirection(viewerName) {
      return this.disabledDirection[viewerName];
    },

    //放大缩小
    changeViewerBoxZoom({ zoom, initzoom = 2 }) {
      //默认this.viewerBox.getZoomLevel :50  对应zoom：2
      // let targetZoom = ((zoom - 0) / initzoom) * this.defaultZoomLevel;
      // this.viewerBox.getZoomLevel();
      // this.viewerBox.animate({
      //   zoom: targetZoom,
      //   speed: 1000,
      // });
      console.log(initzoom);
      const viewerDomeElement = document.getElementById("viewerBox");
      if (viewerDomeElement) {
        // 查找内部的 .psv-canvas-container 元素
        const canvasContainer = viewerDomeElement.querySelector(
          ".psv-canvas-container"
        );
        if(zoom <= 4){
          this.viewerBox.animate({
            zoom: (zoom - 1) * 33 + 1,
            speed: 300,
          });
          if (canvasContainer) {
            // 应用缩放
            canvasContainer.style.transform = `scale(1)`;
            canvasContainer.style.transformOrigin = "center";
            canvasContainer.style.transition = "transform 0.3s ease";
          }
        }else{
          this.viewerBox.animate({
            zoom: 100,
            speed: 300,
          });
          let finalZoom = (zoom - 4)  / 20 + 1;
          if (canvasContainer) {
            // 应用缩放
            canvasContainer.style.transform = `scale(${finalZoom})`;
            canvasContainer.style.transformOrigin = "center";
            canvasContainer.style.transition = "transform 0.3s ease";
          }
        }
      }
    },
    changeViewerBoxZoom2({ zoom }) {
      if (zoom > 1) {
        this.currentScale = zoom;
      } else {
        this.currentScale = 1;
      }
    },
    changeViewerDomeZoom({ zoom, initzoom = 2 }) {
      // eslint-disable-line no-unused-vars
      // let targetZoom = ((zoom - 0) / initzoom) * this.defaultZoomLevel;
      // this.viewerDome.getZoomLevel();
      // this.viewerDome.animate({
      //   zoom: targetZoom,
      //   speed: 1000,
      // });
      console.log(initzoom);

      const viewerDomeElement = document.getElementById("viewerDome");
      if (viewerDomeElement) {
        // 查找内部的 .psv-canvas-container 元素
        const canvasContainer = viewerDomeElement.querySelector(
          ".psv-canvas-container"
        );
        if(zoom <= 4){
          this.viewerDome.animate({
            zoom: (zoom - 1) * 33 + 1,
            speed: 300,
          });
          if (canvasContainer) {
            // 应用缩放
            canvasContainer.style.transform = `scale(1)`;
            canvasContainer.style.transformOrigin = "center";
            canvasContainer.style.transition = "transform 0.3s ease";
          }
        }else{
          this.viewerDome.animate({
            zoom: 100,
            speed: 300,
          });
          let finalZoom = (zoom - 4)  / 20 + 1;
          if (canvasContainer) {
            // 应用缩放
            canvasContainer.style.transform = `scale(${finalZoom})`;
            canvasContainer.style.transformOrigin = "center";
            canvasContainer.style.transition = "transform 0.3s ease";
          }
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@use "@/scss/common.scss" as *;
.video-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;
  .video-box {
    width: px2vh(640);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    padding: px2vh(40) px2vh(40) 0;
    .close-btn-box {
      width: px2vh(30);
      height: px2vh(30);
      position: absolute;
      right: 0;
      top: px2vh(calc(-30 - 12));
      .close-btn-img {
        display: block;
        width: 100%;
        height: 100%;
        cursor: pointer;
      }
    }
    .preview-title {
      position: absolute;
      top: px2vh(calc(-28 - 13));
      left: 0;
      font-family: SourceHanSansCN-Bold;
      font-size: px2vh(18);
      color: #ffffff;
      letter-spacing: px2vh(0.36);
      line-height: px2vh(28);
    }
    .preview-text-style {
      font-family: SourceHanSansCN-Bold;
      font-size: px2vh(18);
      color: #ffffff;
      letter-spacing: px2vh(0.36);
      text-align: center;
      line-height: px2vh(28);
      font-weight: 400;
    }
    .handler-text-style {
      font-family: SourceHanSansCN-Bold;
      font-size: px2vh(14);
      color: #ffffff;
      letter-spacing: px2vh(0.28);
      text-align: center;
      line-height: px2vh(20);
      font-weight: 400;
    }
    .slide-text-style {
      font-family: SourceHanSansCN-Bold;
      font-size: px2vh(14);
      color: #ffffff;
      letter-spacing: px2vh(0.28);
      text-align: center;
      line-height: px2vh(20);
      font-weight: 400;
    }
  }
  .type-default {
    width: px2vh(640);
    height: px2vh(360);
    padding: 0;
    top: 50%;
    .preview-box {
      width: 100%;
      height: 100%;
      background: #000000;
      .preview-video {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .preview-text {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: px2vh(calc(-28 - 12));
    }
    .preview-text-box {
      width: 100%;
      background: #000000;
      padding-bottom: px2vh(28);
      overflow: hidden;
      .preview-text-title {
        font-size: px2vh(18);
        font-family: SourceHanSansCN-Bold;
        color: #fff;
        font-weight: 400;
        margin: px2vh(12) auto 0;
        letter-spacing: px2vh(0.36);
        line-height: px2vh(28);
        text-align: center;
      }
      .preview-text-focallength {
        font-family: SourceHanSansCN-Normal;
        font-size: px2vh(14);
        color: #ffffff;
        letter-spacing: px2vh(0.28);
        text-align: center;
        line-height: px2vh(20);
        font-weight: 400;
        margin: px2vh(8) auto 0;
        text-align: center;
      }
    }

    &.type-default-2{
      width: px2vh(720);
      height: px2vh(496);
      background: #000;
      .preview-box{
        width: px2vh(640);
        height: px2vh(360);
        margin: px2vh(40) auto 0;
        overflow: hidden;
      }
      &.type-default-3{ 
        height: px2vh(860);
        .preview-box{
          height: px2vh(720);
        }
      }
    }
  }
  .type-thermal-img {
    .preview-text-box {
      padding-bottom: px2vh(20);
    }
    width: px2vh(1060);
    height: px2vh(438);
    background: #000000;
    .preview-text-box {
      .preview-text-title {
        margin-top: px2vh(28);
      }
    }
    .type-thermal-img-box {
      width: px2vh(980);
      margin: 0 auto;
      overflow: hidden;
      .type-thermal-img-left {
        float: left;
        width: px2vh(480);
        height: px2vh(270);
        background: #4d4d4d;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
        }
      }
      .type-thermal-img-right {
        float: right;
        width: px2vh(480);
        height: px2vh(270);
        background: #4d4d4d;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
        }
      }
      .type-thermal-img-title-left {
        float: left;
        width: px2vh(480);
        text-align: center;
        font-family: SourceHanSansCN-Bold;
        font-size: px2vh(14);
        color: #ffffff;
        letter-spacing: px2vh(0.28);
        text-align: center;
        line-height: px2vh(28);
        margin-top: px2vh(16);
      }
      .type-thermal-img-title-right {
        float: right;
        width: px2vh(480);
        text-align: center;
        font-family: SourceHanSansCN-Bold;
        font-size: px2vh(14);
        color: #ffffff;
        letter-spacing: px2vh(0.28);
        text-align: center;
        line-height: px2vh(28);
        margin-top: px2vh(16);
      }
    }
  }
  .type-handle-right {
    width: px2vh(920);
    height: px2vh(496);
    background: #000000;
    .content-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .preview-box {
        width: px2vh(640);
        height: px2vh(360);
        background-color: #4d4d4d;
      }
      .handler-box {
        width: px2vh(180);
        height: px2vh(360);
        background-color: #222222;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .text-row {
      display: flex;
      justify-content: space-between;
      .preview-text-box {
        width: px2vh(640);
        .preview-text-title {
          font-size: px2vh(18);
          font-family: SourceHanSansCN-Bold;
          color: #fff;
          font-weight: 400;
          margin: px2vh(12) auto 0;
          letter-spacing: px2vh(0.36);
          line-height: px2vh(28);
          text-align: center;
        }
        .preview-text-focallength {
          font-family: SourceHanSansCN-Normal;
          font-size: px2vh(14);
          color: #ffffff;
          letter-spacing: px2vh(0.28);
          text-align: center;
          line-height: px2vh(20);
          font-weight: 400;
          margin: px2vh(8) auto 0;
          text-align: center;
        }
      }
      .preview-text {
        width: px2vh(640);
      }
      .handler-text {
        margin-top: px2vh(16);
        width: px2vh(180);
      }
    }
  }
  .type-slide-down {
    width: px2vh(720);
    height: px2vh(624);
    background: #000000;
    // top: px2vh(266);
    // transform: translateX(-50%);
    .content-row {
      width: px2vh(640);
      height: px2vh(360);
      background: #4d4d4d;
      .preview-box {
        width: 100%;
        height: 100%;
      }
    }
    .preview-text {
      margin: px2vh(12) auto px2vh(22);
    }
    .preview-text-focallength {
      font-family: SourceHanSansCN-Normal;
      font-size: px2vh(14);
      color: #ffffff;
      letter-spacing: px2vh(0.28);
      text-align: center;
      line-height: px2vh(20);
      font-weight: 400;
      margin: px2vh(8) auto px2vh(36);
      text-align: center;
    }
    .slide-row {
      width: px2vh(640);
      height: px2vh(60);
      background: #222222;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      padding: 0 px2vh(147);
    }
    .slide-text {
      margin-top: px2vh(14);
    }
  }
  .type-handle-slide-down {
    width: px2vh(720);
    height: px2vh(664);
    background: #000000;
    .content-row {
      width: px2vh(640);
      height: px2vh(360);
      background: #4d4d4d;
      .preview-box {
        width: 100%;
        height: 100%;
      }
    }
    .preview-text {
      margin: px2vh(12) auto px2vh(20);
    }
    .preview-text-focallength {
      font-family: SourceHanSansCN-Normal;
      font-size: px2vh(14);
      color: #ffffff;
      letter-spacing: px2vh(0.28);
      text-align: center;
      line-height: px2vh(20);
      font-weight: 400;
      margin: px2vh(8) auto px2vh(36);
      text-align: center;
    }
    .operate-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .slide-box {
        width: px2vh(448);
        height: px2vh(100);
        background: #222222;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .handler-box {
        width: px2vh(170);
        height: px2vh(100);
        background: #222222;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .text-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: px2vh(12);
      .slide-text {
        width: px2vh(448);
      }
      .handler-text {
        width: px2vh(170);
      }
    }
  }
  .type-double-handle-slide-down {
    width: px2vh(560);
    height: px2vh(884);
    background: #000000;
    // .close-btn-box {
    //   width: px2vh(30);
    //   height: px2vh(30);
    //   position: absolute;
    //   top: 0;
    //   right: px2vh(calc(-30 - 12));
    // }
    .content-row {
      width: px2vh(480);
      height: px2vh(270);
      display: flex;
      align-items: center;
      .preview-box {
        width: 100%;
        height: 100%;
      }
    }
    .preview-text {
      margin: px2vh(12) auto px2vh(19.5);
      text-align: left;
      line-height: px2vh(28);
      color: #fff;

      .preview-text-focallength {
        font-family: SourceHanSansCN-Normal;
        font-size: px2vh(14);
        color: #ffffff;
        letter-spacing: px2vh(0.28);
        text-align: left;
        line-height: px2vh(20);
        font-weight: 400;
        display: inline-block;
        padding-left: px2vh(12);
        margin-left: px2vh(12);
        border-left: 1px solid #fff;
      }
    }
    .divider {
      width: 100%;
      height: px2vh(1);
      min-height: 1px;
      background: #3f3f3f;
    }
    .content-second-row {
      margin-top: px2vh(19);
    }
    .operate-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: px2vh(18);
      .slide-box {
        width: px2vh(370);
        height: px2vh(100);
        background: #222222;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .handler-box {
        width: px2vh(100);
        height: px2vh(100);
        background: #222222;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .text-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: px2vh(12);
      .slide-text {
        width: px2vh(370);
      }
      .handler-text {
        width: px2vh(100);
      }
    }
  }
  .type-double-handle-right {
    width: px2vh(760);
    height: px2vh(745);
    background: #000000;
    .content-row {
      width: px2vh(480);
      height: px2vh(270);
      background: #4d4d4d;
      .preview-box {
        width: 100%;
        height: 100%;
      }
    }
    .preview-text {
      margin: px2vh(12) 0 px2vh(23);
      width: px2vh(480);
      text-align: left;
      .preview-text-focallength {
        font-family: SourceHanSansCN-Normal;
        font-size: px2vh(14);
        color: #ffffff;
        letter-spacing: px2vh(0.28);
        text-align: left;
        line-height: px2vh(20);
        font-weight: 400;
        display: inline-block;
        padding-left: px2vh(12);
        margin-left: px2vh(12);
        border-left: 1px solid #fff;
      }
    }
    .divider {
      width: 100%;
      height: px2vh(1);
      min-height: 1px;
      background: #3f3f3f;
    }
    .content-second-row {
      width: 100%;
      height: px2vh(270);
      margin-top: px2vh(19);
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: transparent;
      .preview-box {
        width: px2vh(480);
        height: 100%;
        background: #4d4d4d;
      }
      .handler-box {
        width: px2vh(180);
        height: 100%;
        background: #4d4d4d;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .text-row {
      display: flex;
      align-items: center;
      justify-content: space-between;

      margin-top: px2vh(12);
      .preview-text {
        width: px2vh(480);
        margin: 0;
        text-align: left;
        .preview-text-focallength {
          font-family: SourceHanSansCN-Normal;
          font-size: px2vh(14);
          color: #ffffff;
          letter-spacing: px2vh(0.28);
          text-align: left;
          line-height: px2vh(20);
          font-weight: 400;
          display: inline-block;
          padding-left: px2vh(12);
          margin-left: px2vh(12);
          border-left: 1px solid #fff;
        }
      }
      .handler-text {
        width: px2vh(180);
      }
    }
  }
  .type-video {
    width: px2vh(1300);
    height: px2vh(730);
    padding: 0;
    background: #000000;
    .preview-video {
      width: 100%;
      height: 100%;
    }
  }
  .inspection-intro{
    width: px2vh(520);
    height: px2vh(600);
    padding: 0;
    background: #fff;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    position: absolute;
    .close-btn-box {
      width: px2vh(30);
      height: px2vh(30);
      position: absolute;
      right: 0;
      top: px2vh(calc(-30 - 12));
      .close-btn-img {
        display: block;
        width: 100%;
        height: 100%;
        cursor: pointer;
      }
    }
    .modal-header {
      width: 100%;
      height: px2vh(48);
      background: #41558C;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;

      .logo {
        height: px2vh(14);
      }
    }
    .inspection-intro-title{
      width: 100%;
      text-align: center;
      line-height: px2vh(48);
      font-size: px2vh(24);
      font-family: PingFangSC-Semibold,SourceHanSansCN-Bold;
      letter-spacing: px2vh(0.6);
      font-weight: normal;
      margin: px2vh(36) 0 px2vh(19);
    }
    .inspection-intro-desc{
      width: px2vh(446);
      margin: 0 auto;
      text-align: justify;
      color: #41558C;
      line-height: px2vh(28);
      font-size: px2vh(16);
      font-family: SourceHanSansCN-Medium;
    }
    .inspection-intro-spolight{
      width: px2vh(394);
      margin: px2vh(24) auto;
      list-style-type:none;
      li{
        padding-left: px2vh(14);
        font-family: SourceHanSansCN-Regular;
        font-size: px2vh(14);
        letter-spacing: px2vh(0.28);
        text-align: justify;
        line-height: px2vh(24);
        margin-bottom: px2vh(12);
        position: relative;
        &::before {
          content: "•";
          position: absolute;
          top: 0;
          left: px2vh(-5);
          color: #000;
          font-size: px2vh(16);
        }
      }
    }
  }
}
</style>
